import CheckIcon from '@heroicons/react/outline/esm/CheckIcon.js'

import { useI18n } from '@tribeplatform/react-components/i18n'
import {
  useClearNotificationsCount,
  useReadNotifications,
} from '@tribeplatform/react-sdk/hooks'
import { IconButton } from '@tribeplatform/react-ui-kit/Button'

export const NotificationsMarkAsRead = () => {
  const { mutate: clearNotificationCount } = useClearNotificationsCount()
  const { mutate: readAllNotifications } = useReadNotifications()
  const { $t } = useI18n()

  return (
    <IconButton
      type="button"
      onClick={() => {
        readAllNotifications({ ids: [] })
        clearNotificationCount()
      }}
      icon={<CheckIcon />}
      variant="tertiaryNeutral"
      size="lg"
      accessibilityLabel={$t({
        defaultMessage: 'Mark all as read',
        id: 'Notifications.MarkAllAsRead',
      })}
      tooltip
    />
  )
}
